import React, { useEffect, useState } from 'react';

/** How long a load can take before anything is shown. Most finish sooner. */
export const LOADING_DELAY_MS = 300;

/** True once `ms` has passed since mount — for "only show a loader if it's slow". */
export const useDelayed = (ms = LOADING_DELAY_MS) => {
  const [late, setLate] = useState(false);
  useEffect(() => { const t = setTimeout(() => setLate(true), ms); return () => clearTimeout(t); }, [ms]);
  return late;
};

/**
 * <Loading /> — shown while a screen's data loads. Nothing appears for the first
 * LOADING_DELAY_MS (a quick load goes straight to the content, no flash); after
 * that, one small spinner. The old grey shimmer bars made every page flicker.
 *
 * Variants only set how much room it takes:
 *   "page" / "detail"  centred in the page
 *   "table"            centred inside a card
 */
const Loading = ({ variant = 'page', label }) => {
  const late = useDelayed();
  const inCard = variant === 'table';
  return (
    <div role="status" aria-busy="true" aria-live="polite" className={`cw-loading${inCard ? ' in-card' : ''}`}>
      <span className="cw-sr-only">{label || 'Loading…'}</span>
      {late && <span className="cw-spinner" aria-hidden="true" />}
    </div>
  );
};

export default Loading;
